import React from "react";
import "./App.css";

const App = () => {
  return (
    <div className="container">
      <h1>Oeing Click Click.</h1>
      <h3>- Two Wise Men</h3>
    </div>
  );
};

export default App;
